(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-date"] && !Shopify.designMode) return;
  try {
    (function () {
    const FMT = new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
    document.querySelectorAll('[data-delivery-date]').forEach(function (el) {
      const cutoff = el.dataset.cutoff.split(':').map(Number);
      const leadMin = parseInt(el.dataset.leadMin, 10);
      const leadMax = parseInt(el.dataset.leadMax, 10);
      const now = new Date();
      const cutoffToday = new Date(now);
      cutoffToday.setHours(cutoff[0], cutoff[1], 0, 0);
      const beforeCutoff = now < cutoffToday;

      function addBusinessDays(date, days) {
        const d = new Date(date);
        let added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          const day = d.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return d;
      }

      const base = beforeCutoff ? new Date(now) : addBusinessDays(now, 1);
      const min = addBusinessDays(base, leadMin - (beforeCutoff ? 1 : 0));
      const max = addBusinessDays(base, leadMax - (beforeCutoff ? 1 : 0));
      const span = el.querySelector('span:last-child');
      if (beforeCutoff) {
        span.innerHTML = '<strong class="text-[var(--color-text)]">' + el.dataset.tBefore + ' ' + el.dataset.cutoff + 'h</strong> ' + el.dataset.tAnd + ' ' + FMT.format(min) + (min.getTime() !== max.getTime() ? ' – ' + FMT.format(max) : '');
      } else {
        span.innerHTML = el.dataset.tReceive + ' <strong class="text-[var(--color-text)]">' + FMT.format(min) + (min.getTime() !== max.getTime() ? ' – ' + FMT.format(max) : '') + '</strong>';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recently-viewed"] && !Shopify.designMode) return;
  try {
    (function () {
    const KEY = 'kapi_recently_viewed';
    const root = document.querySelector('[data-recently-viewed]');
    if (!root) return;
    const handle = root.dataset.currentHandle;
    const limit = parseInt(root.dataset.limit, 10) || 4;
    const grid = root.querySelector('[data-recently-grid]');

    let viewed = [];
    try { viewed = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    viewed = viewed.filter(function (h) { return h !== handle; });
    viewed.unshift(handle);
    viewed = viewed.slice(0, 20);
    try { localStorage.setItem(KEY, JSON.stringify(viewed)); } catch (e) {}

    const others = viewed.filter(function (h) { return h !== handle; }).slice(0, limit);
    if (others.length === 0) return;

    Promise.all(others.map(function (h) {
      return fetch('/products/' + h + '?view=card').then(function (r) { return r.ok ? r.text() : null; });
    })).then(function (htmls) {
      const valid = htmls.filter(Boolean);
      if (valid.length === 0) return;
      grid.innerHTML = valid.join('');
      root.classList.remove('hidden');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    const bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    const trigger = document.querySelector('[data-atc-anchor]') || document.querySelector('button[name="add"]:not([form])');
    if (!trigger) return;
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.setAttribute('data-visible', e.isIntersecting ? 'false' : 'true');
      });
    }, { rootMargin: '0px 0px -100px 0px' });
    io.observe(trigger);
  })();
  } catch(e) { console.error(e); }
})();

})();
